{
  "list": {
    "title": "Filtres",
    "create": "Créer un filtre",
    "import": "Importer un filtre",
    "loadError": "Une erreur s'est produite lors du chargement des filtres.",
    "statusAll": "Tous",
    "statusEnabled": "Activé",
    "statusDisabled": "Désactivé",
    "noStatusFilters": "Aucun filtre {{status}}",
    "noFilters": "Aucun filtre ici..",
    "addNew": "Ajouter",
    "copied": "Filtre copié dans le presse-papiers !",
    "copyFailed": "Échec de la copie du JSON dans le presse-papiers.",
    "fetchFailed": "Impossible de récupérer les données du filtre.",
    "deleted": "Le filtre {{name}} a été supprimé",
    "duplicated": "Le filtre {{name}} a été dupliqué",
    "updated": "{{name}} a été mis à jour avec succès",
    "removeTitle": "Supprimer le filtre : {{name}}",
    "removeText": "Es-tu sûr de vouloir supprimer ce filtre ? Cette action est irréversible.",
    "edit": "Modifier",
    "exportJson": "Exporter en JSON",
    "exportJsonDiscord": "Exporter le JSON vers Discord",
    "toggle": "Activer/Désactiver",
    "duplicate": "Dupliquer",
    "delete": "Supprimer",
    "toggleSuccess": "{{name}} a été {{state}} avec succès",
    "enabledState": "activé",
    "disabledState": "désactivé",
    "autoUpdatedTitle": "Ce filtre est automatiquement mis à jour par une liste",
    "priority": "Priorité",
    "actions": "Actions",
    "noActionsDefined": "Aucune action définie. Configure des actions pour activer le snatch.",
    "noActionsEnabled": "Tu dois activer au moins une action dans le filtre, sinon tu n'obtiendras aucun snatch.",
    "downloads": "Téléchargements",
    "per": "par",
    "usesDisabledIndexers": "Utilise des indexeur(s) désactivé(s) : {{names}}",
    "noIndexer": "AUCUN INDEXEUR",
    "sort": {
      "label": "Trier",
      "default": "Plus récent",
      "nameAsc": "Nom A-Z",
      "nameDesc": "Nom Z-A",
      "priorityDesc": "Priorité Haute-Basse",
      "priorityAsc": "Priorité Basse-Haute",
      "createdDesc": "Créés récemment en premier",
      "createdAsc": "Créés récemment en dernier",
      "updatedDesc": "Mis à jour récemment en premier",
      "updatedAsc": "Mis à jour récemment en dernier"
    },
    "indexerFilter": {
      "label": "Indexeur",
      "all": "Tous les indexeurs"
    }
  },
  "details": {
    "tabs": {
      "general": "Général",
      "moviesTv": "Films et séries",
      "music": "Musique",
      "advanced": "Avancé",
      "external": "Externe",
      "actions": "Actions",
      "notifications": "Notifications",
      "new": "NOUVEAU"
    },
    "removeTitle": "Supprimer le filtre : {{name}}",
    "removeText": "Es-tu sûr de vouloir supprimer ce filtre ? Cette action est irréversible.",
    "delete": "Supprimer le filtre",
    "reset": "Réinitialiser les valeurs du formulaire",
    "resetSuccess": "Toutes les valeurs du filtre ont été réinitialisées.",
    "save": "Enregistrer",
    "validationError": "Erreur de validation",
    "validationErrors": "Erreurs de validation",
    "mustSelectClient": "Un client doit être sélectionné"
  },
  "importer": {
    "title": "Importer un filtre (en format JSON ou autodl-irssi)",
    "import": "Importer",
    "cancel": "Annuler",
    "jsonImported": "Filtre '{{name}}' importé avec succès !",
    "jsonImportFailed": "Échec de l'importation des données JSON. Informations enregistrées dans la console.",
    "invalidFormat": "Impossible d'importer ce filtre – ni en format JSON ni en format autodl-irssi.",
    "autodlImportFailed": "Échec de l'importation du filtre autodl-irssi '{{name}}'. Informations enregistrées dans la console.",
    "autodlImportedOne": "Filtre '{{name}}' importé avec succès !",
    "autodlImportedMany": "Les {{count}} filtres ont été importés avec succès !",
    "autodlImportedPartial": "{{success}}/{{total}} filtres importés avec succès. Voir la console pour les détails.",
    "placeholder": "Colle tes données de filtre ici (format JSON autobrr ou configuration complète autodl-irssi)",
    "warnings": "Avertissements d'importation"
  },
  "general": {
    "filterName": "Nom du filtre",
    "filterNamePlaceholder": "ex. Filtre 1",
    "announceTypes": "types d'annonce",
    "announceTypesTooltip": "NOUVEAU ! Correspondre aux releases contenant l'un des types d'annonce sélectionnés.",
    "indexers": "Indexeurs",
    "rulesTitle": "Règles",
    "rulesSubtitle": "Définir les règles de traitement et de sélection des torrents.",
    "minSize": "Taille min.",
    "maxSize": "Taille max.",
    "sizePlaceholder": "ex. 100MiB, 80GB",
    "sizeTooltip": "Prend en charge les unités telles que MB, MiB, GB, etc.",
    "delay": "Délai",
    "delayPlaceholder": "Nombre de secondes pour retarder les actions",
    "delayTooltip": "Nombre de secondes à attendre avant d'exécuter les actions.",
    "priority": "Priorité",
    "priorityPlaceholder": "Nombre plus élevé = priorité plus haute",
    "priorityTooltip": "Les filtres sont vérifiés par ordre de priorité. Nombre plus élevé = priorité plus haute.",
    "maxDownloads": "Téléchargements max.",
    "maxDownloadsPlaceholder": "N'importe quel nombre (0 = illimité)",
    "maxDownloadsTooltip": "Nombre maximum de téléchargements selon l'unité respective.",
    "maxDownloadsPer": "Téléchargements max. par",
    "selectUnit": "Sélectionner l'unité",
    "maxDownloadsPerTooltip": "L'unité de temps pour compter les téléchargements maximum par filtre.",
    "skipDuplicatesProfile": "Profil d'exclusion des doublons",
    "selectProfile": "Sélectionner un profil",
    "skipDuplicatesProfileTooltip": "Sélectionner le profil d'exclusion des doublons.",
    "enabled": "Activé",
    "enabledDescription": "Activer ou désactiver ce filtre."
  },
  "actionsSection": {
    "title": "Actions",
    "subtitle": "Ajouter à des clients de téléchargement ou exécuter des commandes personnalisées.",
    "addNew": "Ajouter",
    "empty": "Aucune action pour l'instant !",
    "deleted": "L'action {{name}} a été supprimée",
    "removeTitle": "Supprimer l'action du filtre",
    "removeText": "Es-tu sûr de vouloir supprimer cette action ? Cette action est irréversible.",
    "actionTitle": "Action",
    "actionSubtitle": "Définir le client de téléchargement pour cette action et son nom",
    "actionType": "Type d'action",
    "selectType": "Sélectionner le type",
    "actionTypeTooltip": "Sélectionner le type d'action pour cette action.",
    "name": "Nom",
    "removeAction": "Supprimer l'action",
    "close": "Fermer"
  },
  "notificationsSection": {
    "title": "Notifications du filtre",
    "subtitle": "Configure les notifications à envoyer pour ce filtre. Ces paramètres remplacent les paramètres de notification globaux.",
    "addNotification": "Ajouter une notification",
    "empty": "Aucune notification spécifique au filtre configurée. Les notifications globales seront utilisées.",
    "selectNotification": "Sélectionner une notification",
    "muted": "En sourdine",
    "eventsCount_one": "{{count}} événement",
    "eventsCount_other": "{{count}} événements",
    "removeTitle": "Supprimer la notification",
    "removeText": "Es-tu sûr de vouloir supprimer cette notification ? Cette action est irréversible.",
    "notificationTitle": "Notification",
    "notificationSubtitle": "Sélectionner le service de notification et les événements à déclencher",
    "notificationService": "Service de notification",
    "selectNotificationService": "Sélectionner une notification",
    "notificationServiceTooltip": "Sélectionner le service de notification à utiliser pour ce filtre.",
    "notificationSettings": "Paramètres de notification",
    "muteFilter": "Mettre le filtre en sourdine",
    "muteFilterDesc": "Désactiver toutes les notifications pour ce filtre. En sourdine, aucune notification ne sera envoyée pour les releases correspondant à ce filtre.",
    "mutedInfo": "Filtre en sourdine – remplace tous les paramètres de notification globaux",
    "triggerEvents": "Événements déclencheurs",
    "pushApproved": "Push approuvé",
    "pushRejected": "Push rejeté",
    "pushError": "Erreur de push",
    "pushApprovedDesc": "Envoyer une notification quand la release est envoyée avec succès au client",
    "pushRejectedDesc": "Envoyer une notification quand la release est rejetée",
    "pushErrorDesc": "Envoyer une notification quand une erreur survient lors du traitement",
    "removeNotification": "Supprimer la notification",
    "close": "Fermer"
  },
  "advanced": {
    "common": {
      "useRegex": "Utiliser Regex",
      "regexTooltip1": "Ce champ prend entièrement en charge les regex (style Golang).",
      "regexTooltip2": "Pense à cocher Utiliser Regex si tu utilises plus que * et ?.",
      "regexTooltip3": "Mode : (?i) insensible à la casse"
    },
    "releases": {
      "title": "Noms de release",
      "subtitle": "Correspondre uniquement à certains noms de release et/ou ignorer d'autres.",
      "match": "Correspondre aux releases",
      "matchPlaceholder": "ex. *some?movie*,*some?show*s01*",
      "except": "Exclure les releases",
      "exceptPlaceholder": "ex. *bad?movie*,*bad?show*s03*",
      "alert": "Demande-toi :",
      "matchWarning": "As-tu une bonne raison d'utiliser Correspondre aux releases plutôt qu'un autre onglet ?",
      "exceptWarning": "As-tu une bonne raison d'utiliser Exclure les releases plutôt qu'un autre onglet ?"
    },
    "groups": {
      "title": "Groupes",
      "subtitle": "Correspondre uniquement à certains groupes et/ou ignorer d'autres.",
      "match": "Correspondre aux groupes de release",
      "matchPlaceholder": "ex. groupe1,groupe2",
      "matchTooltip": "Liste de groupes de release séparés par des virgules à faire correspondre.",
      "except": "Exclure les groupes de release",
      "exceptPlaceholder": "ex. mauvaisgroupe1,mauvaisgroupe2",
      "exceptTooltip": "Liste de groupes de release séparés par des virgules à ignorer (prioritaire sur Correspondre aux groupes de release)."
    },
    "categories": {
      "title": "Catégories",
      "subtitle": "Faire correspondre ou exclure des catégories (si annoncées)",
      "match": "Correspondre aux catégories",
      "matchPlaceholder": "ex. *catégorie*,catégorie1",
      "matchTooltip": "Liste de catégories séparées par des virgules à faire correspondre.",
      "except": "Exclure les catégories",
      "exceptPlaceholder": "ex. *catégorie*",
      "exceptTooltip": "Liste de catégories séparées par des virgules à ignorer (prioritaire sur Correspondre aux catégories)."
    },
    "tags": {
      "title": "Tags",
      "subtitle": "Faire correspondre ou exclure des tags (si annoncés)",
      "match": "Correspondre aux tags",
      "matchPlaceholder": "ex. tag1,tag2",
      "matchTooltip": "Liste de tags séparés par des virgules à faire correspondre.",
      "matchLogic": "Logique de correspondance",
      "matchLogicDefault": "n'importe lequel",
      "matchLogicTooltip": "Logique utilisée pour faire correspondre les tags du filtre.",
      "except": "Exclure les tags",
      "exceptPlaceholder": "ex. tag1,tag2",
      "exceptTooltip": "Liste de tags séparés par des virgules à ignorer (prioritaire sur Correspondre aux tags).",
      "exceptLogic": "Logique d'exclusion",
      "exceptLogicDefault": "n'importe lequel",
      "exceptLogicTooltip": "Logique utilisée pour les tags exclus."
    },
    "uploaders": {
      "title": "Téléverseurs",
      "subtitle": "Faire correspondre ou ignorer des téléverseurs (si annoncés)",
      "match": "Correspondre aux téléverseurs",
      "matchPlaceholder": "ex. téléverseur1,téléverseur2",
      "matchTooltip": "Liste de téléverseurs séparés par des virgules à faire correspondre.",
      "except": "Exclure les téléverseurs",
      "exceptPlaceholder": "ex. anonyme1,anonyme2",
      "exceptTooltip": "Liste de téléverseurs séparés par des virgules à ignorer (prioritaire sur Correspondre aux téléverseurs)."
    },
    "language": {
      "title": "Langue",
      "subtitle": "Faire correspondre ou ignorer des langues (si annoncées)",
      "match": "Correspondre à la langue",
      "except": "Exclure la langue"
    },
    "origins": {
      "title": "Origines",
      "subtitle": "Faire correspondre Internals, Scene, P2P, etc. (si annoncés)",
      "match": "Correspondre aux origines",
      "except": "Exclure les origines"
    },
    "freeleech": {
      "title": "Freeleech",
      "subtitle": "Faire correspondre selon le freeleech (si annoncé)",
      "percent": "Pourcentage de freeleech",
      "percentPlaceholder": "ex. 50,75-100",
      "percentTooltip1": "Le freeleech peut être annoncé comme une valeur booléenne ou un pourcentage selon l'indexeur. Utiliser l'un ou l'autre.",
      "percentTooltip2": "Le bouton Freeleech remplace ce champ s'il est activé.",
      "percentTooltip3": "Consulter la documentation pour plus de détails :",
      "toggle": "Freeleech",
      "toggleDescription": "Ne peut pas être utilisé avec le pourcentage de freeleech. Remplace le pourcentage de freeleech si activé.",
      "toggleTooltip1": "Le freeleech peut être annoncé comme une valeur booléenne ou un pourcentage selon l'indexeur. Utiliser l'un ou l'autre.",
      "toggleTooltip2": "Ce champ remplace le pourcentage de freeleech s'il est activé.",
      "toggleTooltip3": "Voir qui utilise quoi dans la documentation :"
    },
    "feedSpecific": {
      "title": "Spécifique RSS/Torznab/Newznab",
      "subtitle": "Ces options ne s'appliquent qu'aux feeds tels que RSS, Torznab et Newznab",
      "matchDescription": "Correspondre à la description",
      "matchDescriptionPlaceholder": "ex. *some?movie*,*some?show*s01*",
      "exceptDescription": "Exclure la description",
      "exceptDescriptionPlaceholder": "ex. *bad?movie*,*bad?show*s03*",
      "minSeeders": "Seeders min.",
      "maxSeeders": "Seeders max.",
      "minLeechers": "Leechers min.",
      "maxLeechers": "Leechers max.",
      "countPlaceholder": "N'importe quel nombre (0 = illimité)",
      "seedersTooltip": "Nombre de {{type}} selon l'unité respective. Uniquement pour Torznab"
    },
    "rawReleaseTags": {
      "title": "Tags de release bruts",
      "subtitlePrefix": "Utilisateurs avancés uniquement",
      "subtitleSuffix": "Ceci est la chaîne releaseTags brute de l'annonce.",
      "warning": "Ce n'est peut-être pas ce que tu crois. Pour les utilisateurs très avancés qui savent comment les données sont parsées.",
      "match": "Correspondre aux tags de release",
      "except": "Exclure les tags de release",
      "placeholder": "ex. *mkv*,*foreign*"
    }
  },
  "moviesTv": {
    "title": "Films / Séries",
    "placeholder": "ex. Film,Série 1,Série?2",
    "wildcardTooltip": "Filtrage de base avec les jokers * ou remplacer des caractères uniques avec ?",
    "years": "Années",
    "yearsPlaceholder": "ex. 2018,2019-2021",
    "yearsTooltip": "Ce champ accepte une plage d'années et/ou des années séparées par des virgules.",
    "seasonEpisode": {
      "title": "Saisons, épisodes et date",
      "subtitle": "Définir les contraintes de saison, épisode, année, mois et jour.",
      "seasons": "Saisons",
      "seasonsPlaceholder": "ex. 1,3,2-6",
      "seasonsTooltip": "Consulter la documentation pour récupérer uniquement les packs de saison :",
      "episodes": "Épisodes",
      "episodesPlaceholder": "ex. 2,4,10-20",
      "episodesTooltip": "Consulter la documentation pour récupérer uniquement les épisodes :",
      "dailyShows": "Émissions quotidiennes",
      "months": "Mois",
      "monthsPlaceholder": "ex. 4,2-9",
      "monthsTooltip": "Ce champ accepte une plage de mois et/ou des mois séparés par des virgules.",
      "days": "Jours",
      "daysPlaceholder": "ex. 1,15-30",
      "daysTooltip": "Ce champ accepte une plage de jours et/ou des jours séparés par des virgules.",
      "smartEpisode": "Épisode intelligent",
      "smartEpisodeDescription": "Ne pas correspondre aux épisodes plus anciens que le dernier correspondant."
    },
    "quality": {
      "title": "Qualité",
      "subtitle": "Définir les contraintes de résolution, source, codec et autres.",
      "resolutions": "Résolutions",
      "resolutionsTooltip": "Correspondra aux releases contenant l'une des résolutions sélectionnées.",
      "sources": "Sources",
      "sourcesTooltip": "Correspondra aux releases contenant l'une des sources sélectionnées.",
      "codecs": "Codecs",
      "codecsTooltip": "Correspondra aux releases contenant l'un des codecs sélectionnés.",
      "containers": "Conteneurs",
      "containersTooltip": "Correspondra aux releases contenant l'un des conteneurs sélectionnés.",
      "matchHdr": "Correspondre au HDR",
      "matchHdrTooltip": "Correspondra aux releases contenant l'une des désignations HDR sélectionnées.",
      "exceptHdr": "Exclure le HDR",
      "exceptHdrTooltip": "Ne correspondra pas aux releases contenant l'une des désignations HDR sélectionnées (prioritaire sur Correspondre au HDR).",
      "matchOther": "Correspondre à Autre",
      "matchOtherTooltip": "Correspondra aux releases contenant l'une des désignations sélectionnées.",
      "exceptOther": "Exclure Autre",
      "exceptOtherTooltip": "Ne correspondra pas aux releases contenant l'une des autres désignations sélectionnées (prioritaire sur Correspondre à Autre)."
    }
  },
  "music": {
    "artists": "Artistes",
    "artistsPlaceholder": "ex. Artiste Un",
    "albums": "Albums",
    "albumsPlaceholder": "ex. Cet Album",
    "wildcardTooltip": "Filtrage de base avec les jokers * ou remplacer des caractères uniques avec ?",
    "matchRecordLabels": "Correspondre aux labels",
    "matchRecordLabelsPlaceholder": "ex. Anjunabeats, Armada",
    "matchRecordLabelsTooltip": "Liste de labels séparés par des virgules à faire correspondre. Uniquement Orpheus et Redacted prennent en charge ceci.",
    "exceptRecordLabels": "Exclure les labels",
    "exceptRecordLabelsPlaceholder": "ex. Anjunadeep, Armind",
    "exceptRecordLabelsTooltip": "Liste de labels séparés par des virgules à ignorer (prioritaire sur Correspondre aux labels). Uniquement Orpheus et Redacted prennent en charge ceci.",
    "releaseDetails": {
      "title": "Détails de la release",
      "subtitle": "Type (Album, Single, EP, etc.) et année de sortie (si annoncé)",
      "musicType": "Type de musique",
      "musicTypeTooltip": "Correspondra uniquement aux releases avec l'un des types sélectionnés.",
      "years": "Années",
      "yearsPlaceholder": "ex. 2018,2019-2021",
      "yearsTooltip": "Ce champ accepte une plage d'années et/ou des années séparées par des virgules."
    },
    "quality": {
      "title": "Qualité",
      "subtitle": "Format, source, log, etc.",
      "format": "Format",
      "formatTooltip": "Correspondra uniquement aux releases avec l'un des formats sélectionnés. Remplacé par Perfect FLAC.",
      "quality": "Qualité",
      "qualityTooltip": "Correspondra uniquement aux releases avec l'une des qualités sélectionnées. Remplacé par Perfect FLAC.",
      "media": "Média",
      "mediaTooltip": "Correspondra uniquement aux releases avec l'une des sources sélectionnées. Remplacé par Perfect FLAC.",
      "cue": "Cue",
      "cueDescription": "Doit inclure les informations CUE",
      "log": "Log",
      "logDescription": "Doit inclure les informations LOG",
      "logScore": "Score de log",
      "logScorePlaceholder": "ex. 100",
      "logScoreTooltip": "Les scores de log vont de 0 à 100. Remplacé par Perfect FLAC.",
      "or": "OU",
      "perfectFlac": "Perfect FLAC",
      "perfectFlacDescription": "Remplacer toutes les options de qualité, source, format et cue/log/score de log.",
      "perfectFlacTooltip": "Remplacer toutes les options de qualité, source, format et CUE/LOG/score de LOG.",
      "perfectFlacHint": "C'est ce que tu veux dans 90% des cas (plutôt que les options ci-dessus)."
    }
  },
  "external": {
    "title": "Filtres externes",
    "subtitle": "Exécuter des scripts externes ou des webhooks et vérifier le statut dans le cadre du filtrage.",
    "addNew": "Ajouter",
    "empty": "Aucun filtre externe pour l'instant !",
    "removeTitle": "Supprimer le filtre externe",
    "removeText": "Es-tu sûr de vouloir supprimer ce filtre externe ? Cette action est irréversible.",
    "sectionTitle": "Filtre externe",
    "sectionSubtitle": "Définir le type et le nom du filtre",
    "type": "Type",
    "name": "Nom",
    "onError": "En cas d'erreur",
    "selectType": "Sélectionner le type",
    "typeTooltip": "Sélectionner le type pour ce filtre externe.",
    "onErrorTooltip": "Sélectionner l'action en cas d'erreur pour ce filtre externe.",
    "remove": "Supprimer l'externe",
    "close": "Fermer",
    "types": {
      "EXEC": "Exec",
      "WEBHOOK": "Webhook"
    },
    "onErrorOptions": {
      "REJECT": "Rejeter",
      "CONTINUE": "Continuer au suivant"
    },
    "execute": {
      "title": "Exécuter",
      "subtitle": "Spécifier l'exécutable, l'argument et le statut de sortie attendu pour le pré-filtre",
      "path": "Chemin vers l'exécutable",
      "pathPlaceholder": "Chemin absolu vers l'exécutable, ex. /bin/test",
      "pathTooltip": "Pour les commandes personnalisées, spécifie le chemin complet vers le binaire/programme à exécuter. Tu peux aussi inclure tes propres variables statiques :",
      "args": "Arguments Exec",
      "argsPlaceholder": "Arguments, ex. --test \"{{ .TorrentName }}\"",
      "expectedExitStatus": "Statut de sortie attendu"
    },
    "request": {
      "title": "Requête",
      "subtitle": "Spécifier le point de terminaison, les en-têtes et le statut de retour attendu",
      "endpoint": "Point de terminaison",
      "endpointPlaceholder": "Hôte, ex. http://localhost/webhook",
      "endpointTooltip": "URL ou IP vers ton API. Passer des paramètres et configurer les tokens API, etc.",
      "httpMethod": "Méthode HTTP",
      "httpMethodDefault": "Sélectionner la méthode HTTP",
      "httpMethodTooltip": "Sélectionner la méthode HTTP pour ce webhook. Par défaut POST",
      "headers": "En-têtes de requête HTTP",
      "headersPlaceholder": "HEADER=custom1,HEADER2=custom2",
      "expectedStatus": "Code de statut HTTP attendu"
    },
    "retry": {
      "title": "Réessayer",
      "subtitle": "Comportement de nouvelle tentative en cas d'échec",
      "retryStatus": "Code(s) de statut HTTP pour réessayer",
      "retryStatusPlaceholder": "Réessayer sur le statut, ex. 202, 204",
      "retryAttempts": "Tentatives maximum",
      "retryDelaySeconds": "Délai de nouvelle tentative en secondes"
    },
    "payload": {
      "title": "Charge utile",
      "subtitle": "Spécifier ta charge utile JSON",
      "data": "Données (json)",
      "dataPlaceholder": "Données de la requête : { \"key\": \"value\" }"
    }
  },
  "actionComponents": {
    "instance": {
      "title": "Instance",
      "subtitle": "Sélectionner l'instance spécifique qui doit gérer ce filtre de release."
    },
    "common": {
      "category": "Catégorie",
      "categoryPlaceholder": "ex. catégorie",
      "categoryTooltip": "La catégorie doit déjà exister.",
      "savePath": "Chemin d'enregistrement",
      "savePathPlaceholder": "ex. /chemin/complet/vers/dossier_téléchargement",
      "numberNoLimit": "N'importe quel nombre (0 = sans limite)",
      "limitsTitle": "Limites",
      "limitsSubtitle": "Configurer les limites de vitesse/ratio/temps de seed",
      "limitDownloadKib": "Limiter la vitesse de téléchargement (KiB/s)",
      "limitUploadKib": "Limiter la vitesse d'envoi (KiB/s)",
      "limitDownloadKb": "Limiter la vitesse de téléchargement (KB/s)",
      "limitUploadKb": "Limiter la vitesse d'envoi (KB/s)",
      "ratioLimit": "Limite de ratio",
      "seedTimeMinutes": "Limite de temps de seed (minutes)",
      "addPaused": "Ajouter en pause",
      "addPausedDescription": "Ajouter le torrent en pause",
      "skipHashCheck": "Ignorer la vérification du hash",
      "skipHashCheckDescription": "Ajouter le torrent et ignorer la vérification du hash",
      "announceTitle": "Annonce",
      "announceSubtitle": "Définir le nombre de ré-annonces (si nécessaire), supprimer après Y échecs d'annonce, etc.",
      "disableReannounce": "Désactiver la ré-annonce",
      "disableReannounceDescription": "La ré-annonce est activée par défaut. Désactiver si elle n'est pas nécessaire",
      "reannounceInterval": "Intervalle de ré-annonce. Exécuter toutes les X secondes",
      "reannounceIntervalPlaceholder": "7 est la valeur par défaut et recommandée",
      "deleteStalled": "Supprimer les torrents bloqués",
      "deleteStalledDescription": "Supprimer les torrents bloqués après Y tentatives",
      "reannounceMaxAttempts": "Exécuter la ré-annonce Y fois"
    },
    "test": {
      "alert": "Attention !",
      "text": "L'action de test ne fait rien d'autre que vérifier si le filtre fonctionne. Assure-toi que la page Journaux est ouverte pendant le test."
    },
    "exec": {
      "title": "Arguments Exec",
      "subtitle": "Spécifier l'exécutable et ses arguments à exécuter lors d'une correspondance de filtre. Utiliser un chemin absolu.",
      "path": "Chemin vers l'exécutable",
      "pathPlaceholder": "Chemin vers le programme, ex. /bin/test",
      "arguments": "Arguments",
      "argumentsPlaceholder": "Arguments, ex. --test"
    },
    "watchFolder": {
      "title": "Arguments du dossier surveillé",
      "subtitle": "Indiquer où autobrr doit enregistrer les fichiers récupérés. Utiliser un chemin absolu.",
      "directory": "Dossier de surveillance",
      "directoryPlaceholder": "Dossier de surveillance, ex. /home/utilisateur/rwatch"
    },
    "webhook": {
      "title": "Arguments Webhook",
      "subtitle": "Spécifier la charge utile à envoyer au point de terminaison souhaité lors d'une correspondance de filtre.",
      "endpoint": "Point de terminaison",
      "endpointPlaceholder": "Hôte, ex. http://localhost/webhook",
      "endpointTooltip": "URL ou IP vers ton API. Passer des paramètres et configurer les tokens API, etc.",
      "payload": "Charge utile (json)",
      "payloadPlaceholder": "Données de la requête : { \"key\": \"value\" }"
    },
    "arr": {
      "overrideClientName": "Remplacer le nom du client de téléchargement pour arr",
      "overrideClientNameTooltip": "Remplacer le nom du client de téléchargement par rapport à celui défini dans Clients. Utile si tu as plusieurs clients dans l'arr.",
      "overrideClientId": "Remplacer l'ID du client de téléchargement pour arr DÉPRÉCIÉ",
      "overrideClientIdTooltip": "Remplacer l'ID du client de téléchargement par rapport à celui défini dans Clients. Utile si tu as plusieurs clients dans l'arr."
    },
    "qbittorrent": {
      "macrosTooltip": "Ce champ peut utiliser des macros pour transformer/ajouter des valeurs issues des métadonnées :",
      "tags": "Tags",
      "tagsPlaceholder": "ex. tag1,tag2",
      "savePathPlaceholder": "ex. /chemin/complet/vers/dossier_enregistrement",
      "savePathTooltip": "Définir un chemin d'enregistrement personnalisé pour cette action. La gestion automatique des torrents s'en chargera si tu utilises qBittorrent avec des catégories.",
      "downloadPath": "Chemin de téléchargement",
      "downloadPathPlaceholder": "ex. /chemin/complet/vers/dossier_téléchargement",
      "downloadPathTooltip": "Définir un chemin de téléchargement (incomplet) personnalisé pour cette action. La gestion automatique des torrents s'en chargera si tu utilises qBittorrent avec des catégories.",
      "rulesTitle": "Règles",
      "rulesSubtitle": "Configurer les règles du client torrent",
      "ignoreRules": "Ignorer les règles du client existant",
      "ignoreRulesDescription": "Ignorer les règles définies dans les paramètres du client.",
      "contentLayout": "Disposition du contenu",
      "contentLayoutDefault": "Sélectionner la disposition du contenu",
      "priority": "Priorité",
      "priorityDefault": "Désactivé",
      "priorityTooltip": "La file d'attente des torrents sera activée automatiquement si elle est désactivée. Assure-toi de définir tes limites préférées dans ton client.",
      "firstLastPiece": "Télécharger les première et dernière parties en premier",
      "firstLastPieceDescription": "Ajouter le torrent et télécharger les première et dernière parties en premier"
    },
    "deluge": {
      "label": "Label",
      "labelPlaceholder": "ex. label1 (doit exister dans Deluge)",
      "skipHashCheckTooltip": "Cela ne fonctionnera qu'avec Deluge v2."
    },
    "transmission": {
      "label": "Labels du torrent",
      "labelPlaceholder": "ex. label1,label2"
    },
    "rtorrent": {
      "label": "Label",
      "labelPlaceholder": "ex. label1,label2",
      "renameToPath": "Ne pas ajouter le nom du torrent au chemin",
      "renameDefault": "Non"
    },
    "porla": {
      "preset": "Préréglage",
      "presetPlaceholder": "ex. default",
      "presetTooltip": "Un nom de préréglage sensible à la casse tel que configuré dans Porla.",
      "savePathPlaceholder": "ex. /chemin/complet/vers/données/torrent"
    }
  },
  "addForm": {
    "title": "Créer un filtre",
    "subtitle": "Ajouter un nouveau filtre.",
    "closePanel": "Fermer le panneau",
    "name": "Nom",
    "required": "Requis",
    "cancel": "Annuler",
    "create": "Créer",
    "added": "Le filtre {{name}} a été ajouté"
  }
}
